var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.898,13.147c1.847,0,3.349,1.502,3.349,3.349s-1.502,3.349-3.349,3.349-3.349-1.502-3.349-3.349,1.502-3.349,3.349-3.349M5.898,12.147c-2.402,0-4.349,1.947-4.349,4.349s1.947,4.349,4.349,4.349,4.349-1.947,4.349-4.349-1.947-4.349-4.349-4.349h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.102,13.147c1.847,0,3.349,1.502,3.349,3.349s-1.502,3.349-3.349,3.349-3.349-1.502-3.349-3.349,1.502-3.349,3.349-3.349M18.102,12.147c-2.402,0-4.349,1.947-4.349,4.349s1.947,4.349,4.349,4.349,4.349-1.947,4.349-4.349-1.947-4.349-4.349-4.349h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.648,9.594l-3.472-3.024c-.792-.69-1.994-.604-2.68.191l-1.797,2.082c-.874,1.012-.765,2.54.243,3.419l2.015,1.755c.177.154.278.377.278.611v2.901c0,.448.363.811.811.811h0c.448,0,.811-.363.811-.811v-3.692c0-.467-.207-.91-.564-1.21l-.963-.808c-.273-.229-.308-.635-.079-.908l1.423-1.695c.232-.276.645-.308.917-.072l1.654,1.441c.198.173.452.268.715.268h1.513c.347,0,.629-.281.629-.629h0c0-.347-.281-.629-.629-.629h-.825Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.054,
    cy: 4.736,
    r: 1.581
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBike);
export default __webpack_public_path__ + "static/media/map-bike.7aa2d42fe2ce5316c2bc81719fb9eaac.svg";
export { ForwardRef as ReactComponent };